import { useEffect } from 'react'
import { ProjectWrapper, LinkButton } from '../../GlobalStyles'
import { ViewAllProjects } from '../../components/ViewAllProjects'
import { Carousel } from '../../components/Carousel'
import wave from '../../assets/white-wave.svg'

import image1 from '../../assets/creator/creator-home.png'
import image2 from '../../assets/creator/creator-home-new.png'

export const Creatorco = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const projectImages = [image1, image2]
  const captions = ['Before', 'After']

  return (
    <ProjectWrapper>
      <div
        className='banner'
        style={{ background: 'linear-gradient(to right, #DCECFB, #BBDCF7)' }}
      >
        <img src={wave} alt='decorative wave' />
      </div>

      <section className='description'>
        <h1 className='title'>[ <b>Creator.co 2.0</b> ]</h1>
        <div className='summary'>
          <p className='type'>Frontend Development, Responsive Website</p>
          <p className='duration'>Sole Developer • Jan 2023</p>
        </div>

        <div className='details'>
          {/* Historical context note */}
          <p className='note' style={{ fontStyle: 'italic', fontSize: '0.9rem', color: '#888', marginBottom: '20px' }}>
            *The site has since rebranded once again, but this case study highlights my end-to-end frontend work.*
          </p>
          <p>
            Led the complete rebrand and UI/UX overhaul of Creator.co’s public site, modernizing core pages (homepage, landing pages, header/footer) to improve navigation and clarity.
          </p>
        </div>

        <div style={{ margin: '40px 0' }}>
          <Carousel images={projectImages} captions={captions} />
        </div>

        <div className='details'>
          <p>
            Translated designer mockups into a custom WordPress theme using PHP templates and responsive CSS, ensuring pixel-perfect fidelity across all device sizes.
          </p>
        </div>

        <div style={{ margin: '40px 0' }}>
          <iframe
            className='video'
            src='https://www.youtube.com/embed/1PwMpIBHC98'
            title='Creator.co 2.0 Demo'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
            allowFullScreen
          />
        </div>

        <div className='details'>
          <p>
            Delivered full frontend implementation under a two-week timeline ahead of a major event, then enhanced with custom animations and scroll-triggered transitions to elevate brand impact.
          </p>

          <div className='buttons'>
            <LinkButton
              className='black'
              href='https://www.youtube.com/watch?v=1PwMpIBHC98&t=117s'
              target='_blank'
              rel='noopener noreferrer'
            >
              Rebranded Demo
            </LinkButton>
            <LinkButton
              className='white'
              href='https://www.youtube.com/watch?v=wa7VMRikeBE'
              target='_blank'
              rel='noopener noreferrer'
            >
              Original Demo
            </LinkButton>
          </div>
        </div>
      </section>
      <ViewAllProjects />
    </ProjectWrapper>
  )
}
